export default function Step4_Extras({ register }) {
  return (
    <section>
      <h2>4. Dodatne usluge</h2>
      <label style={{ display:'block', marginBottom: 8 }}>
        <input type="checkbox" {...register('extras.assembly')} /> Potrebna demontaža/montaža
      </label>
      <label style={{ display:'block' }}>
        <input type="checkbox" {...register('extras.packing')} /> Potreban materijal za pakovanje
      </label>
    </section>
  );
}
